import { render } from "./cvd-risk.vue?vue&type=template&id=dbde9aa4&scoped=true"
import script from "./cvd-risk.vue?vue&type=script&lang=js"
export * from "./cvd-risk.vue?vue&type=script&lang=js"

import "./cvd-risk.vue?vue&type=style&index=0&id=dbde9aa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbde9aa4"]])

export default __exports__